import { render, staticRenderFns } from "./eidtGroup.vue?vue&type=template&id=12bc13f2&scoped=true&"
import script from "./eidtGroup.vue?vue&type=script&lang=js&"
export * from "./eidtGroup.vue?vue&type=script&lang=js&"
import style0 from "./eidtGroup.vue?vue&type=style&index=0&id=12bc13f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc13f2",
  null
  
)

export default component.exports